import styles from 'assets/jss/LogBook/gridTableStyle';
import {useState} from 'react';
import TableContainer from '@mui/material/TableContainer';
import {makeStyles} from '@mui/styles';
import Grid from "@mui/material/Grid";
import LogBookPagination from "./LogBookPagination";
import {useGridLogBook, usePreFetchGridLogBook} from "hooks/useLogBook";
import {dataStructureGridTable} from "../dataStructureLogBook";
import GridSkeleton from "components/Loading/Logbook/GridSkeleton";
import TableComponent from "./TableComponent";

const useStyles = makeStyles(styles);

const GridTable = (props) => {
    const classes = useStyles();
    // data props is coming from parent Pdf component to GridLogbook and then here :) .
    const {filterChoice, patientId} = props;
    const [page, setPage] = useState(0);
    const {
        isLoading,
        isError,
        error,
        isSuccess,
        data,
        isFetching,
        isPreviousData,
    } = useGridLogBook(patientId, page, filterChoice);
    usePreFetchGridLogBook(patientId,page, filterChoice)

    const finalData = data ? dataStructureGridTable(data, filterChoice) : [];
    const lastWeek = () => {
        setPage(page + 1);
    };
    const nextWeek = () => {
        setPage(page - 1);
    };

    return (
        <Grid
            sx={{
                padding: '10px 10px'
            }}
        >
            <LogBookPagination dateTo={finalData.to} dateFrom={finalData.from} isLoading = {isLoading}
                               page={page} nextWeek={nextWeek} lastWeek={lastWeek}/>
            <Grid minHeight={'460px'}>
                {isLoading || isFetching || isError ?
                    <GridSkeleton/> :
                    <Grid container>
                        <TableContainer className={classes.tableContainerStyle}>
                            <TableComponent finalData={finalData}/>
                        </TableContainer>
                    </Grid>
                }
            </Grid>


        </Grid>
    );
};

export default GridTable;